import React from "react";
import GameTypeIcon from "./GameTypeIcon";

export default function MatkaGameTypesView({
  selectedMarket,
  gameTypes,
  isLoading = false,
  errorMessage = "",
  onBack,
  onSelectGameType,
}) {
  return (
    <div className="container-fluid custom-padding matka-game-types-section">
      {/* Header */}
      <div className="matka-game-types-header mb-4">
        <button
          type="button"
          className="matka-back-link-btn d-inline-flex align-items-center mb-2"
          onClick={onBack}
        >
          <i className="bi bi-arrow-left me-2"></i>
          Back to Markets
        </button>
        <h1 className="matka-market-title-heading">
          {selectedMarket.titleForGames || `${selectedMarket.name} Starline Games`}
        </h1>
        <p className="matka-market-subtitle">
          SELECT GAME TYPE TO PLACE YOUR BETS
        </p>
      </div>

      {isLoading ? (
        <div className="matka-empty-state text-center py-5">
          <p className="text-light fs-5">Loading market...</p>
        </div>
      ) : errorMessage ? (
        <div className="matka-empty-state text-center py-5">
          <p className="text-light fs-5">{errorMessage}</p>
        </div>
      ) : gameTypes.length ? (
        <div className="row g-3 g-md-4">
          {gameTypes.map((gameType) => (
            <div
              className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12"
              key={gameType.id}
            >
              <div
                className="matka-game-type-card text-center"
                onClick={() => onSelectGameType(gameType)}
              >
                <div className="matka-game-type-icon-wrapper mb-3">
                  <GameTypeIcon type={gameType.icon} />
                </div>
                <h4 className="matka-game-type-title">{gameType.title}</h4>
                {gameType.hasBulk && (
                  <div className="matka-bulk-badge-wrapper mt-2">
                    <span className="matka-bulk-badge">BULK</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="matka-empty-state text-center py-5">
          <p className="text-light fs-5">No game types available.</p>
        </div>
      )}
    </div>
  );
}
